import { render, staticRenderFns } from "./sorder.vue?vue&type=template&id=3c614878&scoped=true&"
import script from "./sorder.vue?vue&type=script&lang=js&"
export * from "./sorder.vue?vue&type=script&lang=js&"
import style0 from "./sorder.vue?vue&type=style&index=0&id=3c614878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c614878",
  null
  
)

export default component.exports